import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=27895c45&scoped=true&"
import script from "./reset-password.vue?vue&type=script&lang=js&"
export * from "./reset-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27895c45",
  null
  
)

export default component.exports